export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '1859804', dateTime: 1784925488253 };